import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export abstract class AppConfigService {

  private readonly _environment: any;

  constructor(environment: any) {
    this._environment = environment;
  }

  get environment(): any {
    return this._environment;
  }
}
